import { render, staticRenderFns } from "./StatisticsPreview.vue?vue&type=template&id=09b3eb95&scoped=true"
import script from "./StatisticsPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StatisticsPreview.vue?vue&type=style&index=0&id=09b3eb95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3eb95",
  null
  
)

export default component.exports